import type { CoreApiClient } from "../client";
import { createValveMutations } from "../mutations/valve.mutations";
import { createValveQueries } from "../queries/valve.queries";

export const createValveRepository = (api: CoreApiClient) => ({
  ...createValveQueries(api),
  ...createValveMutations(api),
});
